import React from "react";

import Container from "react-bootstrap/Container";

import { Link, Outlet, matchPath, useLocation } from "react-router-dom";

import styles from "./TabNavigation.module.scss";

export interface TabProps {
  route: string;
  displayName: string;
  component: React.ComponentType<{ participantId: string }>;
}

interface TabNavigationProps {
  tabs: TabProps[];
}

export const TabNavigation = ({ tabs }: TabNavigationProps) => {
  const { pathname } = useLocation();
  const activeTab = tabs.find((tab) => matchPath(tab.route, pathname));

  return (
    <Container fluid className="pt-4">
      <div className={styles.tabNavigation}>
        {tabs.map((tab) => (
          <Link key={tab.route} to={tab.route} className={activeTab === tab ? styles.active : ""}>
            <span className="b3 medium">{tab.displayName}</span>
          </Link>
        ))}
      </div>
      <div className={styles["tab-content"]}>
        <Outlet />
      </div>
    </Container>
  );
};
